import { gql } from "graphql-request"

export default gql`
    query ($siteId: [QueryArgument]) {
        meeting: globalSet(handle: "meeting", siteId: $siteId) {
            siteId
            ... on meeting_GlobalSet {
                isLive
                meetingName
                meetingStartDate: launchDate
                googleAdsNetworkId
            }
        }
        theme: globalSet(handle: "theme", siteId: $siteId) {
            ... on theme_GlobalSet {
                colorPalette {
                    ... on colorPaletteBlock_Entry {
                        color1
                        color2
                        color3
                        color4
                        color5
                    }
                }
            }
        }
    }
`
